import { useSelector } from "react-redux";
import "./RolePlayListingContent.scss";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { Tab, Tabs } from "react-bootstrap";
import useLogin from "../../../../custom-hooks/useLogin";
import RolePlayListingMainComponent from "./RolePlayListingMainComponent";
import { useTranslation } from "react-i18next";
import { SessionKeys } from "../../../../utils/AppUtils";
import ProductCardComponent from "../../ProductCard/ProductCardComponent";
import NotFoundComponent from "../../NotFound/NotFoundComponent";
import { RightArrowIcon } from "../../../../utils/SvgComps";
const RolePlayListingContent = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [onSearchClicked, setOnSearchClicked] = useState(false);
  const { t } = useTranslation();
  const { isLoggedIn } = useLogin();

  const authBroker = useSelector((state) => state.auth.authBroker);

  const [key, setKey] = useState("");

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const tab = params.get("tab");

  const [formattedListing, setFormattedListing] = useState([
    {
      id: "4014",
      is_like: false,
      is_bookmark: false,
      productType: "AI ENABLED ROLE PLAY",
      is_wishlist: false,
      productOrigin: "xsel",
      title: "AI ENABLED ROLE PLAY",
      logoURL:
        "https://cdnstg.training.com/halifax/image/8e30b7d1-7cdd-4acc-bc5f-d423714b9d8f.png",
      logoAltText: "RP",
      bannerURL:
        "https://cdnstg.training.com/halifax/image/b48f3c8e-021c-4d54-801b-d81fb2d84670.jpg",
      tagsArray: ["Halifax", "Role play"],
      description:
        "AI-enabled roleplay offers dynamic, interactive experiences where the AI adapts to various characters, scenarios, and dialogues, creating immersive, personalized storytelling that responds to user actions and choices in real-time.",
      duration: "",
      showHeader: true,
      showProviderIcon: true,
      showLikeMenu: false,
      showSubmitAndReview: false,
      showSubmittedBy: false,
      submittedBy: "",
      submittedOn: "Sep 5, 2024",
      showReviewedBy: false,
      feedbackStatus: false,
      reviewedBy: "1",
      reviewedOn: "Sep 5, 2024",
      showProgres: true,
      showBody: true,
      showFooter: true,
      btnTitle: "Explore",
      cardClassName: "",
      footerLineComp: "",
      btnAction: () => {
        window.open(
          window.location.origin.includes("local") ||
            window.location.origin.includes("192.168") ||
            window.location.origin.includes("dev") ||
            window.location.origin.includes("stg") ||
            window.location.origin.includes("uat")
            ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}` //https://demo.infiniit.ai/xsel-roleplay/?
            : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}`,
          "_blank"
        );
      },
      descAction: () => {
        window.open(
          window.location.origin.includes("local") ||
            window.location.origin.includes("192.168") ||
            window.location.origin.includes("dev") ||
            window.location.origin.includes("stg") ||
            window.location.origin.includes("uat")
            ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${authBroker?.payload?.user?.ai_roleplay_token}` //https://demo.infiniit.ai/xsel-roleplay/?
            : `https://demo.infiniit.ai/halifax-roleplay/login?token=${authBroker?.payload?.user?.ai_roleplay_token}`,
          "_blank"
        );
      },
      bannerAction: () => {
        window.open(
          window.location.origin.includes("local") ||
            window.location.origin.includes("192.168") ||
            window.location.origin.includes("dev") ||
            window.location.origin.includes("stg") ||
            window.location.origin.includes("uat")
            ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${authBroker?.payload?.user?.ai_roleplay_token}` //https://demo.infiniit.ai/xsel-roleplay/?
            : `https://demo.infiniit.ai/halifax-roleplay/login?token=${authBroker?.payload?.user?.ai_roleplay_token}`,
          "_blank"
        );
      },
      priceInfo: {
        isFree: true,
        isPurchased: false,
        isAddToCart: false,
        isOffer: "",
        price: 0,
        offerPrice: 0,
        showText: "",
        textColor: "#292D32",
        teaserViewed: false,
        teaserAccessed: false,
      },
      isLoading: false,
      rightBtnIcon: <RightArrowIcon />,
      leftBtnIcon: "",
    },
  ]);

  useEffect(() => {
    console.log("tab---roleplay", tab);
    if (tab === "1") {
      setKey("participate");
    } else if (tab === "2") {
      setKey("my-roleplay");
    } else if (tab === "3") {
      setKey("to-review");
    }
  }, [tab]);

  useEffect(() => {
    console.log("key---roleplay", key);
  }, [key]);

  useEffect(() => {
    if (onSearchClicked) {
      console.log("roleplay search text", searchText);
    }
    return () => {};
  }, [searchText]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderLP = () => {
    return (
      <RolePlayListingMainComponent
        isAll={key === "participate"}
        isMyRolePlays={key === "my-roleplay"}
        isToReview={key === "to-review"}
      />
    );
  };

  return (
    <div className="contsection rp-listing-content">
      <Tabs
        id="left-tabs-example"
        activeKey={key}
        onSelect={(k) => {
          if (k === "participate") {
            navigate("/learn/roleplay?tab=1");
          } else if (k === "my-roleplay") {
            navigate("/learn/roleplay?tab=2");
          } else if (k === "to-review") {
            navigate("/learn/roleplay?tab=3");
          } else if (k === "new-ai-roleplay") {
            // navigate("/learn/roleplay?tab=4");
          }
          setKey(k);
        }}
      >
        <Tab eventKey={"participate"} title={t("Role play scenarios")}>
          {renderLP()}
        </Tab>
        {isLoggedIn && (
          <Tab eventKey={"my-roleplay"} title={t("My Role plays")}>
            {renderLP()}
          </Tab>
        )}
        {authBroker.payload?.user.role.includes("coach") && (
          <Tab eventKey={"to-review"} title={t("To review")}>
            {renderLP()}
          </Tab>
        )}
        {(localStorage.getItem(SessionKeys.NEW_AI_ROLEPLAY_TOKEN)) && false && (
          <Tab eventKey={"new-ai-roleplay"} title="AI Role play">
            <div className="mt-5">
              <div className="row coursecard-row videosection-cont">
                {formattedListing.length > 0 ? (
                  formattedListing.map((v, i) => {
                    return (
                      <ProductCardComponent
                        {...v}
                        show4={false}
                        // key={`roleplay-${i + 1}`}
                        cardClassName="videocard"
                        lastKey={false}
                        refInfo=""
                      />
                    );
                  })
                ) : (
                  <NotFoundComponent
                    width={400}
                    height={419}
                    showBtn={false}
                    showMsg={true}
                    msgLine={"Nothing here, yet."}
                  />
                )}
              </div>
            </div>
          </Tab>
        )}

        {/* <Tab.Content>
          <Tab.Pane eventKey="participate">
            <ListingBodyComponent
              categoryList={[]}
              selectedCatIds={[]}
              selectedSubCatIds={[]}
              subCatList={[]}
              checkBoxOnChange={() => {}}
              onSelectSubCat={() => {}}
              onSearchClicked={() => {}}
              // searchText={searchText}
              // setSearchText={setSearchText}
              placeHolderMsg={"Search for roleplay..."}
              showSearch={false}
              showSort={true}
              showFilter={false}
              showCategories={false}
              sortOption={sortOption}
              filterOption={[]}
              sortSelected={() => {}}
              setSelectedSort={() => {}}
              isFetching={isLoading}
              setSelectedFilter={() => {}}
              onFilterClicked={() => {}}
              formattedListing={rpListing}
              type={"video"}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="my-roleplay">
            <ListingBodyComponent
              categoryList={[]}
              selectedCatIds={[]}
              selectedSubCatIds={[]}
              subCatList={[]}
              checkBoxOnChange={() => {}}
              onSelectSubCat={() => {}}
              onSearchClicked={() => {}}
              placeHolderMsg={"Search for role play..."}
              showSearch={false}
              showSort={true}
              showFilter={false}
              showCategories={false}
              sortOption={sortOption}
              filterOption={[]}
              sortSelected={() => {}}
              setSelectedSort={() => {}}
              isFetching={isLoading}
              setSelectedFilter={() => {}}
              onFilterClicked={() => {}}
              formattedListing={rpListing}
              type={"video"}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="to-review">
            <ListingBodyComponent
              categoryList={[]}
              selectedCatIds={[]}
              selectedSubCatIds={[]}
              subCatList={[]}
              checkBoxOnChange={() => {}}
              onSelectSubCat={() => {}}
              onSearchClicked={() => {}}
              placeHolderMsg={"Search for role play..."}
              showSearch={false}
              showSort={true}
              showFilter={false}
              showCategories={false}
              sortOption={sortOption}
              filterOption={[]}
              sortSelected={() => {}}
              setSelectedSort={() => {}}
              isFetching={isLoading}
              setSelectedFilter={() => {}}
              onFilterClicked={() => {}}
              formattedListing={rpListing}
              type={"video"}
            />
          </Tab.Pane>
        </Tab.Content> */}
      </Tabs>
    </div>
  );
};

export default RolePlayListingContent;
